import { Button, Carousel, Col, Collapse, Form, Image, Modal, ModalBody, Ratio, Row, Spinner } from "react-bootstrap";
import TitleBarBackButton from "../../../components/layout/title_bar/TitleBarBackButton";
import TitleBarMenuItem from "../../../components/layout/title_bar/TitleBarMenuItem";
import TitleBarTitle from "../../../components/layout/title_bar/TitleBarTitle";
import ConfirmationModal from "../../../components/dialog/ConfirmationModal";
import TitleBarMenu from "../../../components/layout/title_bar/TitleBarMenu";
import { useAddArtworkDocument, useAddArtworkImage, useDeleteArtwork, useGetArtwork, useSetArtworkVisibility, useTokenizeArtwork } from "../../../api/query_hooks";
import { getArtworkDocumentUrl, getArtworkImageUrl, getPropicUrl } from "../../../api/endpoints";
import TitleBar from "../../../components/layout/title_bar/TitleBar";
import Propic from "../../../components/images/propic/Propic";
import { useLocation, useNavigate } from "react-router-dom";
import Panel from "../../../components/layout/panel/Panel";
import { useContext, useEffect, useRef, useState } from "react";
import './artwork.scss';
import Thumbnail from "../../../components/images/thumbnail/Thumbnail";
import { WalletContext } from "../../../contexts/WalletContext";
import TagInput from "../../../components/forms/tag_input/TagInput";
import ImageUploader from "../../../components/forms/image_uploader/ImageUploader";

const Artwork = ({code}) => {
    
    const artworkQuery = useGetArtwork(code);
    const deleteMutation = useDeleteArtwork();
    const tokenizeMutation =  useTokenizeArtwork();
    const visibilityMutation = useSetArtworkVisibility();

    const setVisibility = async (value) => {
        visibilityMutation.mutate({code: code, isPublic: value});
    }

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showTokenizeModal, setShowTokenizeModal] = useState(false);

    const { address, artContract } = useContext(WalletContext);

    const location = useLocation();
    const navigate = useNavigate();


    const deleteArtwork = () => {
        deleteMutation.mutate(code);
        navigate(location.state?.back ? location.state?.back : "/artworks");
    }

    const tokenizeArtwork = () => {
        console.log("requesting artwork tokenization...");
        tokenizeMutation.mutate(code);
    }

    useEffect(() => {
        console.log("CHANGE DETECTED");
        console.log(tokenizeMutation.isSuccess);
        if(tokenizeMutation.isSuccess) {
            console.log(tokenizeMutation.data?.data);
            artContract.mint(address);
        }
    }
    , [tokenizeMutation.isSuccess, navigate]);


    return(
        <>
        {artworkQuery.isLoading &&
            <div className="bg-black d-flex justify-content-center align-items-center container">
                <Spinner animation="border" role="status" aria-describedby="loading" />
            </div>
        }
        {artworkQuery.isError && 
            <Panel>
                {artworkQuery.error.response?.data}
            </Panel>
        }
        {artworkQuery.isSuccess &&
            <Panel id="artwork-panel">
                <ConfirmationModal
                    show={showDeleteModal}
                    setShow={setShowDeleteModal}
                    message="Do you really want to delete this artwork?"
                    onConfirm={deleteArtwork}
                />

                <Modal
                    show={showTokenizeModal}
                    onHide={() => setShowTokenizeModal(false)}
                    centered
                >
                    <Modal.Body className="d-flex flex-column gap-4 bg-dark p-4 rounded">
                        <span>Do you wish to proceed and tokenize this artwork?</span>
                        <div className="d-flex justify-content-between">
                            <Button className="border-secondary" variant="dark" onClick={() => setShowTokenizeModal(false)}>
                                Cancel
                            </Button>
                            <Button variant={"warning"} type="button" onClick={tokenizeArtwork}>
                                Confirm
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>

                <TitleBar className="bg-dark my-2 rounded">
                    <TitleBarBackButton to={location.state?.back ? location.state.back : "/artworks"} />
                    <TitleBarTitle>{artworkQuery.data?.data.title}</TitleBarTitle>
                    <TitleBarMenu disabled={!artworkQuery.data?.data.isOwner}>
                        <TitleBarMenuItem onClick={() => setShowDeleteModal(true)}>
                            <box-icon color='red' name='trash'></box-icon>
                            <span>Delete</span>
                        </TitleBarMenuItem>
                        {!!artworkQuery.data?.data.public &&
                            <TitleBarMenuItem onClick={() => setVisibility(false)}>
                                <box-icon color='white' name='low-vision'></box-icon>
                                <span>Hide</span>
                            </TitleBarMenuItem>
                        }
                        {!artworkQuery.data?.data.public &&
                            <TitleBarMenuItem onClick={() => setVisibility(true)}>
                                <box-icon color='red' name='low-vision'></box-icon>
                                <span>Show</span>
                            </TitleBarMenuItem>
                        }
                    </TitleBarMenu>
                </TitleBar>

                <div className="d-flex flex-column flex-xl-row col-12 mb-4 gap-3">

                    <Col className="d-flex flex-column gap-2 col-12 col-xl-8 mb-auto mt-0">
                        {artworkQuery.data?.data && <ImagePanel artwork={artworkQuery.data.data} />}
                        {artworkQuery.data?.data && <DocumentPanel artwork={artworkQuery.data.data} />} 
                    </Col>

                    <Col className="d-flex flex-column flex-grow-1 justify-content-start gap-2 mb-auto mt-0">
                        {!!artworkQuery.data?.data && <InfoPanel artwork={artworkQuery.data.data} />}
                        {!!artworkQuery.data?.data.user && <OwnerPanel user={artworkQuery.data.data.user} />}
                    </Col>
                </div>
                
            </Panel>
        }
        </>
    )
}


/*
const ImagePanel = ({artwork}) => {

    const [show, setShow] = useState(false);
    const [displayImage, setDisplayImage] = useState(0);
    

    return (
        <>
            <Carousel className="overflow-hidden rounded">
                {artwork.images?.map((image, index) => {
                    return (
                    <Carousel.Item className="bg-dark" key={index}>
                        <Button variant="link" className="d-flex p-0 mx-auto rounded" onClick={() => {
                            setDisplayImage(index);
                            setShow(true);
                        }}>
                            <Image className="object-fit-contain" src={getArtworkImageUrl(image.path)} />
                        </Button>
                    </Carousel.Item>)
                })}
            </Carousel>

            <Modal fullscreen centered show={show} onHide={() => setShow(false)}>
                <ModalBody className="position-relative bg-black d-flex justify-content-center align-items-center p-0 m-0">
                    <Button variant="link" className="p-0 m-0" onClick={() => setShow(false)}>
                        <Image style={{maxHeight: "100vh"}} className="object-fit-contain" src={getArtworkImageUrl(!!artwork.images?.length && artwork.images[displayImage].path)} />
                    </Button>
                    <Button variant="link" className="position-absolute top-0 end-0 m-2" onClick={() => setShow(false)}>
                        <box-icon name='x' size='md' type='solid' color='white' ></box-icon>
                    </Button>
                </ModalBody>
            </Modal>
        </>
    );
}
*/

const ImagePanel = ({ artwork }) => {
    const [show, setShow] = useState(false);
    const [showUpload, setShowUpload] = useState(false);
    const [displayImage, setDisplayImage] = useState(0);
    const [uploads, setUploads] = useState([]);

    const addImageMutation = useAddArtworkImage();

    const images = artwork.images || [];

    const handleSelect = (selectedIndex) => {
        setDisplayImage(selectedIndex);
    };

    const handleUpload = () => {
        if (uploads.length > 0) {
            const fd = new FormData();
            uploads.forEach((image, _) => {
                fd.append("images", image);
            });

            addImageMutation.mutate({code: artwork.code, fd: fd});

            setShowUpload(false);
        } else {
            console.log("No images to upload");
        }
    };

    if (!images.length) {
        return (
            <div className="bg-dark d-flex justify-content-center align-items-center rounded" style={{ minHeight: 300 }}>
                <span className="text-white-50">No images available</span>
            </div>
        );
    }

    return (
         <div className="bg-dark d-flex flex-column col-12  rounded">
            {/* Carosello con frecce */}
            <Carousel
                activeIndex={displayImage}
                onSelect={handleSelect}
                interval={null}
                className="overflow-hidden rounded mb-0"
                indicators={false}
                controls={false}
                nextIcon={<span aria-hidden="true" className="carousel-control-next-icon" />}
                prevIcon={<span aria-hidden="true" className="carousel-control-prev-icon" />}
            >
                {images.map((image, index) => (
                    <Carousel.Item className="bg-dark" key={index}>
                        <Button
                            variant="link"
                            className="d-flex p-0 mx-auto rounded"
                            onClick={() => setShow(true)}
                        >
                            <Image
                                className="object-fit-contain"
                                src={getArtworkImageUrl(image.path)}
                                alt={`Artwork image ${index + 1}`}
                            />
                        </Button>
                    </Carousel.Item>
                ))}
            </Carousel>

            {/* Barra delle miniature */}
            <div className="d-flex flex-row justify-content-start overflow-x-auto w-100 p-1">
                {artwork.isOwner && (
                    <>
                        <Button
                            variant="dark"
                            className="p-0 rounded d-flex justify-content-center align-items-center"
                            style={{
                                width: 128,
                                height: 128,
                                minWidth: 128,
                                minHeight: 128,
                                position: "relative"
                            }}
                            onClick={() => setShowUpload(true)}
                            aria-label="Add images"
                        >
                            <box-icon name='plus' color='white' size='md'></box-icon>
                        </Button>
                    </>
                )}
                {images.map((img, idx) => (
                    <Button
                        key={img.id || idx}
                        variant="link"
                        className={`p-0 border-2 rounded ${displayImage === idx ? "border-white-50" : "border-dark"}`}
                        style={{
                            width: 128,
                            height: 128,
                            minWidth: 128,
                            minHeight: 128,
                            overflow: "hidden",
                            background: "#222"
                        }}
                        onClick={() => setDisplayImage(idx)}
                        aria-label={`Show image ${idx + 1}`}
                    >
                        <Image
                            src={getArtworkImageUrl(img.path)}
                            alt={`Thumbnail ${idx + 1}`}
                            style={{ objectFit: "cover", width: "100%", height: "100%" }}
                            className={displayImage === idx ? "opacity-100" : "opacity-75"}
                            fluid
                        />
                    </Button>
                ))}
            </div>

            {/* Modal fullscreen */}
            <Modal fullscreen centered show={show} onHide={() => setShow(false)}>
                <ModalBody className="position-relative bg-black d-flex justify-content-center align-items-center p-0 m-0">
                    <Button variant="link" className="p-0 m-0" onClick={() => setShow(false)}>
                        <Image
                            style={{ maxHeight: "100vh" }}
                            className="object-fit-contain"
                            src={getArtworkImageUrl(images[displayImage].path)}
                            alt={`Artwork image ${displayImage + 1}`}
                        />
                    </Button>
                    <Button
                        variant="link"
                        className="position-absolute top-0 end-0 m-2"
                        onClick={() => setShow(false)}
                        aria-label="Close image"
                    >
                        <box-icon name='x' size='md' type='solid' color='white' ></box-icon>
                    </Button>
                </ModalBody>
            </Modal>

            {/* Upload Modal */}
            <Modal
                fullscreen="sm"
                size="lg"
                show={showUpload}
                onHide={() => setShowUpload(false)}
                centered
                backdrop="static"
                keyboard={false}
                className="bg-dark"
            >
                <ModalBody className="d-flex flex-column gap-4 bg-dark p-4 rounded">
                    <span className="text-white-50">Upload new images</span>
                    <ImageUploader
                        label="Add images"
                        className="d-flex flex-column mt-2 mb-3 ms-md-3 pe-md-4 col-md-12"
                        images={uploads}
                        setImages={setUploads}
                        fileLimit={8}
                    />
                    <div className="d-flex justify-content-between">
                        <Button
                            variant="dark"
                            className="border-secondary"
                            onClick={() => setShowUpload(false)}
                            aria-label="Cancel upload"
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="warning"
                            type="button"
                            onClick={() => handleUpload()}
                            aria-label="Confirm upload"
                        >
                            Confirm
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};


const DocumentPanel = ({artwork}) => {

    const [open, setOpen] = useState(false);
    const [showUpload, setShowUpload] = useState(false);
    const [uploads, setUploads] = useState([]);

    const addDocumentMutation = useAddArtworkDocument();

    const handleUpload = () => {
        if (uploads.length > 0) {
            const fd = new FormData();
            uploads.forEach((doc, _) => {
                fd.append("documents", doc);
            });

            addDocumentMutation.mutate({code: artwork.code, fd: fd});

            setShowUpload(false);
        } else {
            console.log("No images to upload");
        }
    }
    

    return (
        <>
            <div className="bg-dark d-flex flex-column col-12 rounded">
                <Button
                    className="px-4 py-3"
                    variant="dark"
                    onClick={() => setOpen(!open)}
                    aria-controls="artwork-docs"
                    aria-expanded={open}
                >
                    <p className="d-flex text-white-50 user-select-none m-0">Artwork documents<box-icon color="#AAA" name='chevron-down'></box-icon></p>
                </Button>
                <Collapse in={open}>
                    <div id="artwork-docs">
                        <div className="d-flex gap-3 col-12 overflow-x-auto p-4">

                            {artwork.isOwner &&
                                <Thumbnail
                                    as="button"
                                    src={process.env.PUBLIC_URL+"/add.png"}
                                    className="hov-bg-1 w-15 p-4 border border-2"
                                    onClick={() => setShowUpload(true)}
                                    ariaDescribeBy="add document"
                                />
                            }

                            {artwork.documents?.map((document, index) => {
                                return (
                                    <div key={index} className="flex-center flex-column">
                                        <Thumbnail
                                            as="link"
                                            to={getArtworkDocumentUrl(document.path)}
                                            target="_blank"
                                            src={process.env.PUBLIC_URL+"/default_pdf.png"}
                                            alt={document.path?.split('/').pop()}
                                            className="hov-bg-1 w-100 rounded "
                                        />
                                        <p className="text-white-50 user-select-none">{document.path?.split('/').pop()}</p>
                                    </div>
                                )
                            })}

                        </div>
                    </div>
                </Collapse>
            </div>

            {/* Upload Modal */}
            <Modal
                fullscreen="sm"
                size="lg"
                show={showUpload}
                onHide={() => setShowUpload(false)}
                centered
                backdrop="static"
                keyboard={false}
                className="bg-dark"
            >
                <ModalBody className="d-flex flex-column gap-4 bg-dark p-4 rounded">
                    <span className="text-white-50">Upload new images</span>
                    <ImageUploader
                        label="Add images"
                        className="d-flex flex-column mt-2 mb-3 ms-md-3 pe-md-4 col-md-12"
                        images={uploads}
                        setImages={setUploads}
                        fileLimit={8}
                        allowPdf={true}
                    />
                    <div className="d-flex justify-content-between">
                        <Button
                            variant="dark"
                            className="border-secondary"
                            onClick={() => setShowUpload(false)}
                            aria-label="Cancel upload"
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="warning"
                            type="button"
                            onClick={() => handleUpload()}
                            aria-label="Confirm upload"
                        >
                            Confirm
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
      </>
    );
}


const InfoPanel = ({artwork}) => {

    const [updateMode, setUpdateMode] = useState(false);
    const [tags, setTags] = useState(artwork.tags.map(tag => tag.tag));

    if(updateMode) return (
        <Col className="bg-dark d-flex flex-column gap-3 p-4 pe-3 rounded">

            <Form className="d-flex flex-column gap-3">
                <Form.Group className="mb-3" controlId="formTitle">
                    <Form.Label className="text-white-50">Title</Form.Label>
                    <Form.Control type="text" placeholder="Enter title" defaultValue={artwork.title} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formAuthor">
                    <Form.Label className="text-white-50">Author</Form.Label>
                    <Form.Control type="text" placeholder="Enter author" defaultValue={artwork.author} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formYear">
                    <Form.Label className="text-white-50">Year</Form.Label>
                    <Form.Control type="text" placeholder="Enter year" defaultValue={artwork.year} />   
                </Form.Group>

                <Form.Group className="mb-3" controlId="formType">
                    <Form.Label className="text-white-50">Type</Form.Label>
                    <Form.Control type="text" placeholder="Enter type" defaultValue={artwork.type} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formTechnique">
                    <Form.Label className="text-white-50">Technique</Form.Label>
                    <Form.Control type="text" placeholder="Enter technique" defaultValue={artwork.technique} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formSize">
                    <Form.Label className="text-white-50">Size</Form.Label>
                    <Form.Control type="text" placeholder="Enter size" defaultValue={artwork.size} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formDescription">
                    <Form.Label className="text-white-50">Description</Form.Label>
                    <Form.Control as="textarea" rows={3} placeholder="Enter description" defaultValue={artwork.description} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formTags">
                    <Form.Label className="text-white-50">Tags</Form.Label>
                    <TagInput className="my-3 ms-md-3 pe-md-4 col-12" tags={tags} setTags={setTags} />
                </Form.Group>

                <Button variant={"warning"} type="button" onClick={() => setUpdateMode(false)}>
                    Update
                </Button>
                <Button variant={"dark"} type="button" className="border-secondary" onClick={() => setUpdateMode(false)}>
                    Cancel
                </Button>
            </Form>

        </Col>
    );

    return (
        <Col className="bg-dark d-flex flex-column gap-3 p-4 pe-3 rounded">

            <Row className="d-flex flex-row col-12">
                <Col>
                    <p className="d-inline text-white-50 me-2 user-select-none">Artwork Info</p>
                </Col>
                {artwork.isOwner &&
                    <Col>
                        <Button variant="link" className="d-flex p-0" onClick={() => setUpdateMode(true)}>
                            <box-icon name='edit' size='SM' type='solid' color='white' ></box-icon>
                        </Button>
                    </Col>
                }
            </Row>

            <Row className="d-flex flex-row col-12">
                <Col>
                    <p className="d-inline text-white-50 me-2 user-select-none">Title</p>
                </Col>
                <Col>
                    <p className="d-inline word-break">{artwork.title}</p>
                </Col>
            </Row>

            <Row className="d-flex flex-row col-12">
                <Col>
                    <p className="d-inline text-white-50 me-2 user-select-none">Author</p>
                </Col>
                <Col>
                    <p className="d-inline word-break">{artwork.author}</p>
                </Col>
            </Row>

            {(!!artwork.year) &&
            <Row className="d-flex flex-row col-12">
                <Col>
                    <p className="d-inline text-white-50 me-2 user-select-none">Year</p>
                </Col>
                <Col>
                    <p className="d-inline word-break">{artwork.year}</p>
                </Col>
            </Row>
            }

            <Row className="d-flex flex-row col-12">
                <Col>
                    <p className="d-inline text-white-50 me-2 user-select-none">Type</p>
                </Col>
                <Col>
                    <p className="d-inline word-break">{artwork.type}</p>
                </Col>
            </Row>

            {(!!artwork.size) &&
            <Row className="d-flex flex-row col-12">
                <Col>
                    <p className="d-inline text-white-50 me-2 user-select-none">Size</p>
                </Col>
                <Col>
                    <p className="d-inline word-break">{artwork.size}</p>
                </Col>
            </Row>
            }

            {(!!artwork.technique) &&
            <Row className="d-flex flex-row col-12">
                <Col>
                    <p className="d-inline text-white-50 me-2 user-select-none">Technique</p>
                </Col>
                <Col>
                    <p className="d-inline word-break">{artwork.technique}</p>
                </Col>
            </Row>
            }

            {(!!artwork.description) &&
            <Row className="d-flex flex-row col-12">
                <Col>
                    <p className="d-inline text-white-50 me-2 user-select-none">Description</p>
                </Col>
                <Col>
                    <p className="d-inline word-break">{artwork.description}</p>
                </Col>
            </Row>
            }

            
            {(!!artwork.tags?.length) &&
            <Row className="d-flex flex-row col-12">
                <Col>
                    <p className="d-inline text-white-50 me-2 user-select-none">Tags</p>
                </Col>
                <Col>
                    {artwork.tags.map((tag, index) => {
                        return <span key={index}>#{tag.tag} </span>
                    })}
                </Col>
            </Row>
            }

        </Col>
    );
}


const OwnerPanel = ({user}) => {
    
    return (
        // <Col className="bg-dark flex-grow-1 d-flex flex-column gap-3 p-4 pe-3 rounded"></Col>
        <Col className="bg-dark d-flex flex-column p-4 rounded">

            <p className="text-white-50 user-select-none mb-4">Owner info</p>

            <div className="bg-dark d-flex gap-4 rounded">
                <Propic className="w-33" src={getPropicUrl(user.propic)} />
                <Col className="d-flex flex-column justify-content-center">
                    <p>{user.username}</p>
                    <p>{user.email}</p>
                </Col>
            </div>

        </Col>
    );
}


export default Artwork;